export default __webpack_public_path__ + "static/media/audio.d3a5fad3.svg";